import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { useState } from 'react';
import { createTracker } from 'usage-tracker';
import CreateToolModal from 'payments-embed-points-lib/components/Modals/CreateToolModal';
import { useIsPaymentsApproved } from 'growth-payments-core/hooks/useIsPaymentsApproved';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EnableReportButton = ({
  categoryId,
  location
}) => {
  const [isCreateToolModalOpen, setIsCreateToolModalOpen] = useState(false);
  const handleButtonClick = () => {
    setIsCreateToolModalOpen(true);
  };
  const isPaymentsApproved = useIsPaymentsApproved();
  let tool = categoryId;
  if (categoryId === 'payments' && !isPaymentsApproved) {
    tool = 'setUpPayments';
  }
  const usageTracker = createTracker({
    standalone: true
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonWrapper, {
      position: "absolute",
      insetInlineEnd: "0",
      insetBlockStart: "-50",
      children: /*#__PURE__*/_jsxs(Button, {
        use: "tertiary",
        size: "small",
        onClick: () => {
          usageTracker.track('Reporting', 'Report Interaction', {
            action: 'createToolButtonClick',
            tool,
            source: location
          });
          handleButtonClick();
        },
        children: [/*#__PURE__*/_jsx(HelpIcon, {
          color: "icon-core-on-fill-default",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `reports.zeroState.${tool}.enableReportTooltip`
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.zeroState.enableReport"
        })]
      })
    }), isCreateToolModalOpen && /*#__PURE__*/_jsx(CreateToolModal, {
      onClose: () => setIsCreateToolModalOpen(false),
      page: "analyticsSubSuite",
      tool: tool
    })]
  });
};
export default EnableReportButton;